import type { Subscription } from '../../../types';

import selectSubscription from '../../../helpers/data/select-subscription';
import useData from '@blueshift-ui/fetch/dist/hooks/use-data';

function useSubscription(subscriptionId?: string, requestOptions = {}) {
  return useData<Subscription | null>({
    queryKey: ['subscription', subscriptionId],
    queryOptions: {
      enabled: Boolean(subscriptionId),
      select: selectSubscription,
    },
    request: {
      url: `/v1/subscriptions/${subscriptionId}`,
      ...requestOptions,
    },
  });
}

export default useSubscription;
